import axios from "axios";
import "./utils/ga";
import analyticsHelper from "./helpers/analytics.helper";

window.appGlobalCache = {};
window.sessionStorage.clear();

window.axios = axios.create();
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["X-Client-Token"] = window.clientConfig.token;
window.axios.defaults.headers.common["X-Project-Key"] = window.appConfig.project.key;

// ---

window.addEventListener("error", analyticsHelper.error);
window.addEventListener("unhandledrejection", analyticsHelper.unhandledRejection);
